// src/pages/Users.js

import React, { useState, useEffect, useCallback } from "react";
import { getUsers } from "../api/quontxApi";
import Pagination from "../components/Pagination"; // Assuming you have this component
import UserCard from "../components/UserCard";
import AddUserModal from "../components/AddUserModal";

const ITEMS_PER_PAGE = 5; // You can adjust this

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchUsers = useCallback(
    async (page) => {
      // Only show full-page loader on the very first load
      if (users.length === 0) setLoading(true);
      try {
        const response = await getUsers(page, ITEMS_PER_PAGE);
        setUsers(response.data.data || []);
        setTotalItems(response.data.total_count || 0);
        setCurrentPage(page);
      } catch (err) {
        setError("Failed to fetch users. Please try again later.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [users.length]
  );

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage, fetchUsers]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleUserAction = () => {
    // A single handler for both adding and deleting to refresh data
    fetchUsers(currentPage);
  };

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  if (loading)
    return <div className="text-center p-8 text-white">Loading users...</div>;
  if (error) return <div className="text-center p-8 text-red-400">{error}</div>;

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-white">User Management</h1>
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-colors duration-200"
        >
          + Add New User
        </button>
      </div>

      <div className="flex flex-col gap-4">
        {users.length > 0 ? (
          users.map((user) => (
            <UserCard
              key={user.uuid}
              user={user}
              onUserDeleted={handleUserAction}
            />
          ))
        ) : (
          <div className="text-center p-8 bg-qtx-darker rounded-lg text-qtx-gray">
            No users found.
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="mt-6">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}

      <AddUserModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onUserAdded={handleUserAction}
      />
    </div>
  );
};

export default Users;
